import { render, staticRenderFns } from "./box-input-group.vue?vue&type=template&id=600b6789&scoped=true&"
import script from "./box-input-group.vue?vue&type=script&lang=js&"
export * from "./box-input-group.vue?vue&type=script&lang=js&"
import style0 from "./box-input-group.vue?vue&type=style&index=0&id=600b6789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b6789",
  null
  
)

export default component.exports